import { loggerCallback } from './msal-logger-callback';
/**
 * Build MSAL config based on authorization settings
 * @param settings Authorization settings
 */
export var buildMsalConfig = function (settings) {
    var uipAuthorityDomain = settings.uipAuthorityDomain, uipSignUpSignInPolicy = settings.uipSignUpSignInPolicy, uipClientId = settings.uipClientId, uipTenantId = settings.uipTenantId;
    return {
        auth: {
            clientId: uipClientId || '',
            authority: "https://" + uipAuthorityDomain + "/" + uipTenantId + "/" + uipSignUpSignInPolicy,
            knownAuthorities: [uipAuthorityDomain || ''],
            redirectUri: location.origin,
        },
        cache: {
            cacheLocation: 'localStorage',
            storeAuthStateInCookie: false,
        },
        system: {
            loggerOptions: { loggerCallback: loggerCallback },
        },
    };
};
